import Location from "./location";

export default class Address {

    public isValid         : boolean
    public placeId         : ID
    public address         : string
    public location        : Location

    constructor(data: any) {

        this.isValid      = _.get(data, "isValid", false)
        this.placeId      = _.get(data, "placeId", null)
        this.address      = _.get(data?.text, "text", "")
        this.location     = _.get(data, "location", null)
    }

    static initFromJson(data:JSONObject):Address {
        return new Address(
            data.placePrediction
        )
    }

    toJSON():JSONObject {
        return {
            placeId     : this.placeId,
            address     : this.address,
            location    : this.location.toJSON()
        }
    }
}
